import React, { Component } from 'react';
import ReactTable from "react-table-6"
import "react-table-6/react-table.css";
import $ from 'jquery';
import { ToastContainer, toast } from "react-toastify";
import { DialogComponent } from '@syncfusion/ej2-react-popups';
import GetDomains from '../../GetDomains';
import Select from 'react-select';
import { Progress } from 'react-sweet-progress';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import "react-sweet-progress/lib/style.css";
import { CheckBoxComponent } from '@syncfusion/ej2-react-buttons';


class ImportExportFiles extends Component {
  constructor() {
    super();

    this.dialogClose = () => {
      this.setState({ hideupdateDialog: false, hideAddDialog: false });
    };

    this.settings = { effect: 'Zoom', duration: 400, delay: 0 };

    //for update dialog component ok click
    this.Okbutton = [{
      buttonModel: {
        content: 'OK',
        cssClass: 'e-flat',
        isPrimary: true,
      },
      'click': () => {
        this.fetchImpExpDataApi()
        this.dialogClose();
      }
    }];
    this.addedButton = [{
      buttonModel: {
        content: 'OK',
        cssClass: 'e-flat',
        isPrimary: true,
      },
      'click': () => {
        this.fetchImpExpDataApi()
        this.dialogClose();
        this.setState({
          disabled: false
        })
      }
    }];

    //for utterance dialog component ok click
    this.buttons = [{
      buttonModel: {
        content: 'Yes',
        cssClass: 'e-flat',
        isPrimary: true,

      },
      'click': props => {
        this.deleteRow(this.state.propsId)
        this.setState({ disabled: false })

      }
    }
      , {
      buttonModel: {
        content: 'No',
        cssClass: 'e-flat',
        isPrimary: true,
      },
      'click': () => {
        this.setState({
          hideDeletePopup: false,
          disabled: false
        });
      }
    }];

    //for delete success
    this.deleteSuccessbuttons = [{
      buttonModel: {
        content: 'Ok',
        cssClass: 'e-flat',
        isPrimary: true,

      },
      'click': props => {
        this.dialogInstance.hide();
        this.fetchImpExpDataApi()
        this.setState({ disabled: false })
      }
    }];

    this.state = {
      data: [{
        id: '',
        text: '',
        userId: '',
        valueType: '',
        description: '',
        valueType: [],
        userId: '',
        displayName: '',
        contactNumber: '',
        preferredLanguage: '',
        conversationId: '',
        deleteRow: false,
      }],
      domains: [],
      domainId: null,
      languageId: null,
      utData: [],
      disabled: false,
      editedId: '-1',
      editImageSrc: './assets/images/edit.svg',
      contentEditable: "false",
      showStore: false,
      hidden: false,
      hideAddDialog: false,
      hideupdateDialog: false,
      hideDeletePopup: false,
      hideDeleteSuccessPopup: false,
      hideAbbTextChooseFile: false,
      successResp: false,
      selectedFile: "",
      selectedDomainValue: null,
      selectedLanguageValue: null,
      faqButtonDiable: true,
      faqAsXlsxButtonDiable: true,
      sluProgress: true,
      mltProgress: true,
      mlcdProgress: true,
      namedEntityProgress: true,
      backendApiProgress: true,
      faqhideChoseFile: false,
      faqAsXlsxHideChoseFile: false,
      sluhideChoseFile: false,
      mlthideChoseFile: false,
      apihideChoseFile: false,
      entityhideChoseFile: false,
      langSpecihideChoseFile: false,
      percentage: 0,
      subsProgress: true,
      customEntuProgress: true,
      subshideChoseFile: false,
      custEntihideChoseFile: false,
      progressStatus: null,
      faqPercentage: 0,
      faqAsXlsxPercentage: 0,
      sluPercentage: 0,
      mltPercentage: 0,
      mlcdPercentage: 0,
      apiPercentage: 0,
      nePercentage: 0,
      subPercentage: 0,
      custEntPercentage: 0,
      faqProgressStatus: null,
      faqAsXlsxProgressStatus: null,
      sluProgressStatus: null,
      mltProgressStatus: null,
      mlcdProgressStatus: null,
      apiProgressStatus: null,
      neProgressStatus: null,
      subsProgressStatus: null,
      customEntuProgressStatus: null,
      abbreviationUploadStatus: null,
      hideDialogDirectiveChooseFile: false,
      dialogDirectivePercentage: 0,
      dialogDirectiveStatus: null,
      dialogDirectiveProgress: true,
      hideOutputDDChooseFile: false,
      outputDDPercentage: 0,
      outputDDStatus: null,
      outputDDProgress: true,
      disableAbbreviationImport: true,
      abbreviationUploadPercentage: 0
    }
    this.sluDomains = [];
    this.editImageSrc = "./assets/images/edit.svg";
    this.saveImageSrc = "./assets/images/save.svg";
    this.faqLoadLanguages = [];
    this.valueTypeVar = [];
  }

  notifyFailToCreate() {
    toast(<b style={{ color: "red" }}>Oops! Error occurred. Please try again</b>, {
      position: "top-center",
      color: "red"

    });
  }
  handleDomainChange = (e) => {
    this.state.selectedDomainValue = e.label;
    this.state.domainId = e.value;
    localStorage.setItem("faqDomainName", e.label);
    localStorage.setItem("faqDomainId", e.value);
    this.setState(this.state);
    // this.loadData();
  }
  loadDomains = () => {
    var domainList = GetDomains();
    var isDomainIdInCurrentProject = false;
    for (var i = 0; i < domainList.length; i++) {
      if (localStorage.getItem("faqDomainId") !== undefined &&
        domainList[i]["domainId"] === localStorage.getItem("faqDomainId")) {
        isDomainIdInCurrentProject = true;
      }
      this.sluDomains.push({ "value": domainList[i]["domainId"], "label": domainList[i]["domain"] });
    }

    if (this.props.location.state !== undefined) {
      if (isDomainIdInCurrentProject) {
        this.state.selectedDomainValue = localStorage.getItem("faqDomainName");
        this.state.domainId = localStorage.getItem("faqDomainId");
      } else {
        this.state.selectedDomainValue = this.sluDomains[0].label;
        this.state.domainId = domainList[0]["domainId"];
      }
    } else {
      this.state.selectedDomainValue = this.sluDomains[0].label;
      this.state.domainId = domainList[0]["domainId"];
    }
  }

  handleLangChange = (e) => {
    this.state.selectedLanguageValue = e.label;
    this.state.languageId = e.value;
    localStorage.setItem("name", e.label);
    localStorage.setItem("languageId", e.value);
    this.setState(this.state);
  }

  componentDidMount() {
    setTimeout(() => {
      this.loadDomains();
      this.fetchLanguagesApi();
    }, 300);

    var thisController = this;
    document.addEventListener("projectChanged", function (event) {
      thisController.faqLoadLanguages = [];
      thisController.sluDomains = [];
      thisController.projectId = event.projectId;
      thisController.loadDomains();
      thisController.fetchLanguagesApi(event.projectId);
      thisController.refreshData();
    });

  }
  componentWillUnmount() {
    clearTimeout(window.importStatusTimeoutHandle);
    clearTimeout(window.importSluStatusTimeoutHandle);
    clearTimeout(window.importMltStatusTimeoutHandle);
    clearTimeout(window.importBackendApiStatusTimeoutHandle);
    clearTimeout(window.importEntitiesStatusTimeoutHandle);
    clearTimeout(window.importLangSpecEntitesStatusTimeoutHandle);
    clearTimeout(window.importSubsStatusTimeoutHandle);
    clearTimeout(window.importCustomEntiStatusTimeoutHandle);
    clearTimeout(window.importDialogDStatusTimeoutHandle);
    clearTimeout(window.importOutputDDStatusTimeoutHandle);
    clearTimeout(window.abbTextStatusTimeoutHandle);
  }
  fetchImpExpDataApi = (longDate) => {
    var conversationController = this;

    $.ajax({
      url: "/api/conversations",
      async: false,
      method: 'GET',
      data: {
        projectId: localStorage.getItem("currentProjectId"),
        date: longDate,
        escalationChecked: this.state.escalatedChecked,
        attendedChecked: this.state.attendedChecked,
      },
      headers: {
        "Authorization": "Bearer " + localStorage.getItem("access_token"),
        "Content-Type": "application/json",
      },
      success: function (res) {
        if (res.success === true) {
          var tagKeys = res.result;
          conversationController.setState({
            data: tagKeys,
            successResp: true
          })
        }
      }


    });
  }

  notifySuccessToast(response) {
    toast.dismiss();
    toast(<b>
      <img src="./assets/images/done.svg" style={{ paddingRight: '0px' }} content="" />
      &nbsp;&nbsp;{response}</b>, {
      position: "top-center"
    });
  }
  notifyFileNotPresent(response) {
    toast.dismiss();
    toast(<b>
      <img
        src="assets/images/warn.svg"
        style={{ paddingRight: "0px", height: "20px", width: "20px" }}
        content=""
      />
      &nbsp;&nbsp;{response}</b>, {
      position: "top-center"
    });
  }

  notifyErrorToast(response) {
    toast.dismiss();
    toast(<b style={{ color: "red" }}>{response}</b>, {
      position: "top-center",
      color: "red"
    });
  }


  uploadFaqApi = () => {

    if ($('#inputFaqFile')[0].files[0] == undefined) {
      this.notifyFileNotPresent("Please select FAQ file before import");

    } else if ($('#inputFaqFile')[0].files[0].size >= 52428800) {
      this.notifyFileNotPresent("Size of the file exceeds its maximum permitted size of 20971520 bytes");
      this.state.faqButtonDiable = true;
      this.setState(this);
    } else if (this.state.domainId == null) {
      this.notifyFileNotPresent("Please select domain");

    } else if (this.state.languageId == null) {
      this.notifyFileNotPresent("Please select language");
    } else {
      this.state.faqhideChoseFile = true;
      this.state.faqButtonDiable = false;
      this.setState(this);
      var importExportController = this;
      var domainId = this.state.domainId;
      var language = this.state.languageId;
      var fileResult = this.state.fileResult;
      var formData = new FormData();
      formData.append("projectIdString", localStorage.getItem("currentProjectId"));
      formData.append("domainIdString", domainId);
      formData.append("language", language);
      formData.append("contentType", "FAQ");
      formData.append("uploadedBy", JSON.parse(localStorage.getItem("user_details"))["emailId"]);
      formData.append('document', $('#inputFaqFile')[0].files[0]);
      // var uploadFaqTimer = setInterval(function () {
      //   clearTimeout(uploadFaqTimer);

      $.ajax({
        url: '/api/faq-upload',
        method: "POST",
        type: "POST",
        data: formData,
        cache: false,
        contentType: false,
        processData: false,
        headers: {
          Authorization: "Bearer " + localStorage.getItem("access_token"),
        },
        xhr: function () {
          var xhr = new window.XMLHttpRequest();
          //Upload progress
          xhr.upload.addEventListener(
            "progress",
            function (evt) {
              if (evt.lengthComputable) {
                var percentComplete = Math.floor(
                  (evt.loaded / evt.total) * 100
                );
                importExportController.state.faqPercentage = percentComplete;
                importExportController.setState(importExportController);
                console.log("Current percentage", percentComplete);
              }
            },
            false
          );
          return xhr;
        },
        success: function (data) {
          if (data.success === true) {
            // window.importStatusTimeoutHandle = setInterval(function () {
            //   importExportController.faqImportStatusApi(data.result);
            // }, 1000);
            importExportController.notifySuccessToast("Importing FAQs initiated");
            importExportController.state.faqButtonDiable = true;
            importExportController.setState(this);
          } else {
            clearTimeout(window.importStatusTimeoutHandle);
            importExportController.notifyErrorToast(data.result);
            importExportController.state.faqButtonDiable = true;
            importExportController.state.faqProgressStatus = "error";
            importExportController.state.faqPercentage = 100;
            importExportController.setState(importExportController.state);
          }
        },
        error: function (xhr) {
          if (xhr.status == 401) {
            window.location.href = "/platform/";
          }
        }
      });

      // }, 2000);
    }
  }

  uploadFaqAsXlsxApi = () => {

    if ($('#inputFaqAsXlsxFile')[0].files[0] == undefined) {
      this.notifyFileNotPresent("Please select FAQ file before import");

    } else if ($('#inputFaqAsXlsxFile')[0].files[0].size >= 52428800) {
      this.notifyFileNotPresent("Size of the file exceeds its maximum permitted size of 52428800 bytes");
      this.state.faqAsXlsxButtonDiable = true;
      this.setState(this.state);
    } else if (this.state.domainId == null) {
      this.notifyFileNotPresent("Please select domain");

    } else if (this.state.languageId == null) {
      this.notifyFileNotPresent("Please select language");
    } else {
      this.state.faqAsXlsxHideChoseFile = true;
      this.state.faqAsXlsxButtonDiable = false;
      this.setState(this.state);
      var importExportController = this;
      var domainId = this.state.domainId;
      var language = this.state.languageId;
      var formData = new FormData();
      formData.append("projectIdString", localStorage.getItem("currentProjectId"));
      formData.append("domainIdString", domainId);
      formData.append("language", language);
      formData.append("contentType", "FAQ");
      formData.append("uploadedBy", JSON.parse(localStorage.getItem("user_details"))["emailId"]);
      formData.append('document', $('#inputFaqAsXlsxFile')[0].files[0]);
      var uploadFaqAsXlsxTimer = setInterval(function () {
        clearTimeout(uploadFaqAsXlsxTimer);

        $.ajax({
          url: '/api/faq-upload-xlsx',
          type: 'POST',
          headers: {
            'Authorization': "Bearer " + localStorage.getItem("access_token"),
          },
          data: formData,
          processData: false,
          contentType: false,
          success: function (data) {
            if (data.success === true) {
              importExportController.notifySuccessToast("Importing FAQs as Xlsx initiated");
              importExportController.state.faqAsXlsxButtonDiable = true;
              importExportController.state.faqAsXlsxPercentage = 100;
              importExportController.setState(this);
            } else {
              importExportController.notifyErrorToast(data.result);
              importExportController.state.faqAsXlsxButtonDiable = true;
              importExportController.state.faqAsXlsxProgressStatus = "error";
              importExportController.state.faqAsXlsxPercentage = 100;
              importExportController.setState(importExportController.state);
            }
          },
          error: function (xhr) {
            if (xhr.status == 401) {
              window.location.href = "/platform/";
            }
          }
        });
      }, 2000);
    }
  }

  uploadSluApi = () => {

    if ($('#inputSluFile')[0].files[0] == undefined) {
      this.notifyFileNotPresent("Please choose Intents and Automation file before import");
      this.state.sluProgress = true;
      this.setState(this);
    } else if ($('#inputSluFile')[0].files[0].size >= 52428800) {
      this.notifyFileNotPresent("Size of the file exceeds its maximum permitted size of 20971520 bytes");
      this.state.sluProgress = true;
      this.setState(this);
    } else if (this.state.domainId == null) {
      this.notifyFileNotPresent("Please select domain");

    } else if (this.state.languageId == null) {
      this.notifyFileNotPresent("Please select language");
    } else {
      this.state.sluhideChoseFile = true;
      this.state.sluProgress = false;
      this.setState(this);
      var importExportController = this;
      var domainId = this.state.domainId;
      var language = this.state.languageId;
      var fileResult = this.state.fileResult;
      var formData = new FormData();
      formData.append("domainIdString", domainId);
      formData.append("projectIdString", localStorage.getItem("currentProjectId"));
      formData.append("language", language);
      formData.append("contentType", "SLU");
      formData.append("uploadedBy", JSON.parse(localStorage.getItem("user_details"))["emailId"]);
      formData.append('document', $('#inputSluFile')[0].files[0]);
      // var uploadSluTimer = setInterval(function () {
      // clearTimeout(uploadSluTimer);
      $.ajax({
        url: '/api/slu-import',
        method: "POST",
        type: "POST",
        data: formData,
        cache: false,
        contentType: false,
        processData: false,
        headers: {
          Authorization: "Bearer " + localStorage.getItem("access_token"),
        },
        xhr: function () {
          var xhr = new window.XMLHttpRequest();
          //Upload progress
          xhr.upload.addEventListener(
            "progress",
            function (evt) {
              if (evt.lengthComputable) {
                var percentComplete = Math.floor(
                  (evt.loaded / evt.total) * 100
                );
                importExportController.state.sluPercentage = percentComplete;
                importExportController.setState(importExportController);
                console.log("Current percentage", percentComplete);
              }
            },
            false
          );
          return xhr;
        },
        success: function (data) {
          if (data.success === true) {
            // window.importSluStatusTimeoutHandle = setInterval(function () {
            //   importExportController.sluImportStatusApi(data.result);
            // }, 1000);
            importExportController.notifySuccessToast("Importing Intents & Automations initiated");
            importExportController.state.sluProgress = true;
            importExportController.setState(this);
          } else {
            // clearTimeout(window.importSluStatusTimeoutHandle);
            importExportController.notifyErrorToast(data.result);
            importExportController.state.sluProgress = true;
            importExportController.state.sluProgressStatus = "error";
            importExportController.state.sluPercentage = 100;
            importExportController.setState(importExportController.state);
          }
        },
        error: function (xhr) {
          if (xhr.status == 401) {
            window.location.href = "/platform/";
          } else if (xhr.status == 500) {
            clearTimeout(window.importSluStatusTimeoutHandle);
            importExportController.notifyFailToCreate();
            importExportController.state.sluProgress = true;
            importExportController.state.sluProgressStatus = "error";
            importExportController.state.sluPercentage = 100;
            importExportController.setState(importExportController.state);
          }
        }
      });
      // }, 2000);
    }
  }


  uploadMltsApi = () => {
    if ($('#inputMltFile')[0].files[0] == undefined) {
      this.notifyFileNotPresent("Please choose Automation Response file before import");
      this.state.mltProgress = true;
      this.setState(this);
    } else if ($('#inputMltFile')[0].files[0].size >= 52428800) {
      this.notifyFileNotPresent("Size of the file exceeds its maximum permitted size of 52428800 bytes");
      this.state.mltProgress = true;
      this.setState(this);
    } else if (this.state.domainId == null) {
      this.notifyFileNotPresent("Please select domain");

    } else if (this.state.languageId == null) {
      this.notifyFileNotPresent("Please select language");
    } else {
      this.state.mlthideChoseFile = true;
      this.state.mltProgress = false;
      this.setState(this);
      var importExportController = this;
      var domainId = this.state.domainId;
      var language = this.state.languageId;
      var fileResult = this.state.fileResult;
      var formData = new FormData();
      formData.append("domainIdString", domainId);
      formData.append("projectIdString", localStorage.getItem("currentProjectId"));
      formData.append("language", language);
      formData.append("contentType", "MLT");
      formData.append("uploadedBy", JSON.parse(localStorage.getItem("user_details"))["emailId"]);
      formData.append('document', $('#inputMltFile')[0].files[0]);
      // var uploadMltTimer = setInterval(function () {
      //   clearTimeout(uploadMltTimer);
      $.ajax({
        url: '/api/mlt-import',
        method: "POST",
        type: "POST",
        data: formData,
        cache: false,
        contentType: false,
        processData: false,
        headers: {
          Authorization: "Bearer " + localStorage.getItem("access_token"),
        },
        xhr: function () {
          var xhr = new window.XMLHttpRequest();
          //Upload progress
          xhr.upload.addEventListener(
            "progress",
            function (evt) {
              if (evt.lengthComputable) {
                var percentComplete = Math.floor(
                  (evt.loaded / evt.total) * 100
                );
                importExportController.state.mltPercentage = percentComplete;
                importExportController.setState(importExportController);
                console.log("Current percentage", percentComplete);
              }
            },
            false
          );
          return xhr;
        },
        success: function (data) {
          if (data.success === true) {
            // window.importMltStatusTimeoutHandle = setInterval(function () {
            //   importExportController.mltImportStatusApi(data.result);
            // }, 1000);
            importExportController.notifySuccessToast("Importing Automation Responses initiated");
            importExportController.state.mltProgress = true;
            importExportController.setState(this);
          } else {
            clearTimeout(window.importMltStatusTimeoutHandle);
            importExportController.notifyErrorToast(data.result);
            importExportController.state.mltProgress = true;
            importExportController.state.mltProgressStatus = "error";
            importExportController.state.mltPercentage = 100;
            importExportController.setState(importExportController.state);
          }
        },
        error: function (xhr) {
          if (xhr.status == 401) {
            window.location.href = "/platform/";
          }
        }
      });
      // }, 2000);
    }
  }

  uploadBackendApiApi = () => {
    if ($('#inputBackendApiFile')[0].files[0] == undefined) {
      this.notifyFileNotPresent("Please choose Backend API file before import");
      this.state.backendApiProgress = true;
      this.setState(this);
    } else if ($('#inputBackendApiFile')[0].files[0].size >= 52428800) {
      this.notifyFileNotPresent("Size of the file exceeds its maximum permitted size of 52428800 bytes");
      this.state.backendApiProgress = true;
      this.setState(this);
    } else if (this.state.domainId == null) {
      this.notifyFileNotPresent("Please select domain");

    } else if (this.state.languageId == null) {
      this.notifyFileNotPresent("Please select language");
    } else {
      this.state.apihideChoseFile = true;
      this.state.backendApiProgress = false;
      this.setState(this);
      var importExportController = this;
      var domainId = this.state.domainId;
      var language = this.state.languageId;
      var fileResult = this.state.fileResult;
      var formData = new FormData();
      formData.append("domainIdString", domainId);
      formData.append("projectIdString", localStorage.getItem("currentProjectId"));
      formData.append("language", language);
      formData.append("contentType", "BACKEND_API");
      formData.append("uploadedBy", JSON.parse(localStorage.getItem("user_details"))["emailId"]);
      formData.append('document', $('#inputBackendApiFile')[0].files[0]);
      // var uploadTimer = setInterval(function () {
      //   clearTimeout(uploadTimer);
      $.ajax({
        url: '/api/backend-api-import',
        method: "POST",
        type: "POST",
        data: formData,
        cache: false,
        contentType: false,
        processData: false,
        headers: {
          Authorization: "Bearer " + localStorage.getItem("access_token"),
        },
        xhr: function () {
          var xhr = new window.XMLHttpRequest();
          //Upload progress
          xhr.upload.addEventListener(
            "progress",
            function (evt) {
              if (evt.lengthComputable) {
                var percentComplete = Math.floor(
                  (evt.loaded / evt.total) * 100
                );
                importExportController.state.apiPercentage = percentComplete;
                importExportController.setState(importExportController);
                console.log("Current percentage", percentComplete);
              }
            },
            false
          );
          return xhr;
        },
        contentType: false,
        success: function (data) {
          if (data.success === true) {
            // window.importBackendApiStatusTimeoutHandle = setInterval(function () {
            //   importExportController.backendApiImportStatusApi(data.result);
            // }, 1000);
            importExportController.notifySuccessToast("Importing Backend APIs initiated");
            importExportController.state.backendApiProgress = true;
            importExportController.setState(this);
          } else {
            clearTimeout(window.importBackendApiStatusTimeoutHandle);
            importExportController.notifyErrorToast(data.result);
            importExportController.state.backendApiProgress = true;
            importExportController.state.apiProgressStatus = "error";
            importExportController.state.apiPercentage = 100;
            importExportController.setState(importExportController.state);
          }
        },
        error: function (xhr) {
          if (xhr.status == 401) {
            window.location.href = "/platform/";
          }
        }
      });
      // }, 2000);
    }
  }

  uploadEntitiesApi = () => {
    if ($('#inputEntityFile')[0].files[0] == undefined) {
      this.notifyFileNotPresent("Please choose Multilingual Entities file before import");

    } else if ($('#inputEntityFile')[0].files[0].size >= 104857600) {
      this.notifyFileNotPresent("Size of the file exceeds its maximum permitted size of 100Mb");
      this.state.mlcdProgress = true;
      this.setState(this);
    } else if (this.state.domainId == null) {
      this.notifyFileNotPresent("Please select domain");

    } else if (this.state.languageId == null) {
      this.notifyFileNotPresent("Please select language");
    } else {
      this.state.entityhideChoseFile = true;
      this.state.mlcdProgress = false;
      this.setState(this);
      var importExportController = this;
      var domainId = this.state.domainId;
      var language = this.state.languageId;
      var fileResult = this.state.fileResult;
      var formData = new FormData();
      formData.append("domainIdString", domainId);
      formData.append("projectIdString", localStorage.getItem("currentProjectId"));
      formData.append("language", language);
      formData.append("contentType", "MLCD");
      formData.append("uploadedBy", JSON.parse(localStorage.getItem("user_details"))["emailId"]);
      formData.append('document', $('#inputEntityFile')[0].files[0]);
      // var uploadTimer = setInterval(function () {
      //   clearTimeout(uploadTimer);
      $.ajax({
        url: '/api/mlcd-import',
        method: "POST",
        type: "POST",
        data: formData,
        cache: false,
        contentType: false,
        processData: false,
        headers: {
          Authorization: "Bearer " + localStorage.getItem("access_token"),
        },
        xhr: function () {
          var xhr = new window.XMLHttpRequest();
          //Upload progress
          xhr.upload.addEventListener(
            "progress",
            function (evt) {
              if (evt.lengthComputable) {
                var percentComplete = Math.floor(
                  (evt.loaded / evt.total) * 100
                );
                importExportController.state.mlcdPercentage = percentComplete;
                importExportController.setState(importExportController);
                console.log("Current percentage", percentComplete);
              }
            },
            false
          );
          return xhr;
        },
        success: function (data) {
          if (data.success === true) {
            // window.importEntitiesStatusTimeoutHandle = setInterval(function () {
            //   importExportController.entitiesImportStatusApi(data.result);
            // }, 1000);
            importExportController.notifySuccessToast("Importing Multilingual Entities initiated");
            importExportController.state.mlcdProgress = true;
            importExportController.setState(this);
          } else {
            clearTimeout(window.importEntitiesStatusTimeoutHandle);
            importExportController.notifyErrorToast(data.result);
            importExportController.state.mlcdProgress = true;
            importExportController.state.mlcdProgressStatus = "error";
            importExportController.state.mlcdPercentage = 100;
            importExportController.setState(importExportController.state);
          }
        },
        error: function (xhr) {
          if (xhr.status == 401) {
            window.location.href = "/platform/";
          }
        }
      });
      // }, 2000);
    }
  }

  uploadLangSpecificEntitiesApi = () => {
    if ($('#inputLangSpecificEntityFile')[0].files[0] == undefined) {
      this.notifyFileNotPresent("Please choose Language Specific Entities file before import")
    } else if ($('#inputLangSpecificEntityFile')[0].files[0].size >= 52428800) {
      this.notifyFileNotPresent("Size of the file exceeds its maximum permitted size of 20971520 bytes");
      this.state.namedEntityProgress = true;
      this.setState(this);
    } else if (this.state.domainId == null) {
      this.notifyFileNotPresent("Please select domain");

    } else if (this.state.languageId == null) {
      this.notifyFileNotPresent("Please select language");
    } else {
      this.state.langSpecihideChoseFile = true;
      this.state.namedEntityProgress = false;
      this.setState(this);
      var importExportController = this;
      var domainId = this.state.domainId;
      var language = this.state.languageId;
      var fileResult = this.state.fileResult;
      var formData = new FormData();
      formData.append("domainIdString", domainId);
      formData.append("projectIdString", localStorage.getItem("currentProjectId"));
      formData.append("language", language);
      formData.append("contentType", "NAMED_ENTITY");
      formData.append("uploadedBy", JSON.parse(localStorage.getItem("user_details"))["emailId"]);
      formData.append('document', $('#inputLangSpecificEntityFile')[0].files[0]);
      // var uploadTimer = setInterval(function () {
      //   clearTimeout(uploadTimer);
      $.ajax({
        url: '/api/named-entity-import',
        method: "POST",
        type: "POST",
        data: formData,
        cache: false,
        contentType: false,
        processData: false,
        headers: {
          Authorization: "Bearer " + localStorage.getItem("access_token"),
        },
        xhr: function () {
          var xhr = new window.XMLHttpRequest();
          //Upload progress
          xhr.upload.addEventListener(
            "progress",
            function (evt) {
              if (evt.lengthComputable) {
                var percentComplete = Math.floor(
                  (evt.loaded / evt.total) * 100
                );
                importExportController.state.nePercentage = percentComplete;
                importExportController.setState(importExportController);
                console.log("Current percentage", percentComplete);
              }
            },
            false
          );
          return xhr;
        },
        success: function (data) {
          if (data.success === true) {
            // window.importLangSpecEntitesStatusTimeoutHandle = setInterval(function () {
            //   importExportController.languageSpecificEntitiesImportStatusApi(data.result);
            // }, 1000);
            importExportController.notifySuccessToast("Importing Language Specific Entities initiated");
            importExportController.state.namedEntityProgress = true;
            importExportController.setState(this);
          } else {
            clearTimeout(window.importLangSpecEntitesStatusTimeoutHandle);
            importExportController.notifyErrorToast(data.result);
            importExportController.state.namedEntityProgress = true;
            importExportController.state.neProgressStatus = "error";
            importExportController.state.nePercentage = 100;
            importExportController.setState(importExportController.state);
          }
        },
        error: function (xhr) {
          if (xhr.status == 401) {
            window.location.href = "/platform/";
          }
        }
      });
      // }, 2000);
    }
  }

  uploadSubsApi = () => {
    if ($('#inputSubsFile')[0].files[0] == undefined) {
      this.notifyFileNotPresent("Please choose Substitution file before import");

    } else if ($('#inputSubsFile')[0].files[0].size >= 52428800) {
      this.notifyFileNotPresent("Size of the file exceeds its maximum permitted size of 52428800 bytes");
      this.state.subsProgress = true;
      this.setState(this);
    } else if (this.state.domainId == null) {
      this.notifyFileNotPresent("Please select domain");

    } else if (this.state.languageId == null) {
      this.notifyFileNotPresent("Please select language");
    } else {
      this.state.subshideChoseFile = true;
      this.state.subsProgress = false;
      this.setState(this);
      var importExportController = this;
      var domainId = this.state.domainId;
      var language = this.state.languageId;
      var fileResult = this.state.fileResult;
      var formData = new FormData();
      formData.append("projectIdString", localStorage.getItem("currentProjectId"));
      formData.append("domainIdString", domainId);
      formData.append("language", language);
      formData.append("contentType", "SUBSTITUTION");
      formData.append("uploadedBy", JSON.parse(localStorage.getItem("user_details"))["emailId"]);
      formData.append('document', $('#inputSubsFile')[0].files[0]);
      // var uploadTimer = setInterval(function () {
      //   clearTimeout(uploadTimer);
      $.ajax({
        url: '/api/subs-upload',
        method: "POST",
        type: "POST",
        data: formData,
        cache: false,
        contentType: false,
        processData: false,
        headers: {
          Authorization: "Bearer " + localStorage.getItem("access_token"),
        },
        xhr: function () {
          var xhr = new window.XMLHttpRequest();
          //Upload progress
          xhr.upload.addEventListener(
            "progress",
            function (evt) {
              if (evt.lengthComputable) {
                var percentComplete = Math.floor(
                  (evt.loaded / evt.total) * 100
                );
                importExportController.state.subPercentage = percentComplete;
                importExportController.setState(importExportController);
                console.log("Current percentage", percentComplete);
              }
            },
            false
          );
          return xhr;
        },
        success: function (data) {
          if (data.success === true) {
            // window.importSubsStatusTimeoutHandle = setInterval(function () {
            //   importExportController.subsImportStatusApi(data.result);
            // }, 1000);
            importExportController.notifySuccessToast("Importing Substitution initiated");
            importExportController.state.subsProgress = true;
            importExportController.setState(this);
          } else {
            clearTimeout(window.importSubsStatusTimeoutHandle);
            importExportController.notifyErrorToast(data.result);
            importExportController.state.subsProgress = true;
            importExportController.state.subsProgressStatus = "error";
            importExportController.state.subPercentage = 100;
            importExportController.setState(importExportController.state);
          }
        },
        error: function (xhr) {
          if (xhr.status == 401) {
            window.location.href = "/platform/";
          }
        }
      });
      // }, 2000);
    }
  }



  uploadCustomEntiApi = () => {
    if ($('#inputCustomEntity')[0].files[0] == undefined) {
      this.notifyFileNotPresent("Please choose Custom Entity file before import");

    } else if ($('#inputCustomEntity')[0].files[0].size >= 52428800) {
      this.notifyFileNotPresent("Size of the file exceeds its maximum permitted size of 52428800 bytes");
      this.state.customEntuProgress = true;
      this.setState(this);
    } else if (this.state.domainId == null) {
      this.notifyFileNotPresent("Please select domain");

    } else if (this.state.languageId == null) {
      this.notifyFileNotPresent("Please select language");
    } else {
      this.state.custEntihideChoseFile = true;
      this.state.customEntuProgress = false;
      this.setState(this);
      var importExportController = this;
      var domainId = this.state.domainId;
      var language = this.state.languageId;
      var fileResult = this.state.fileResult;
      var formData = new FormData();
      formData.append("projectIdString", localStorage.getItem("currentProjectId"));
      formData.append("domainIdString", domainId);
      formData.append("language", language);
      formData.append("contentType", "CUSTOM_ENTITY");
      formData.append("uploadedBy", JSON.parse(localStorage.getItem("user_details"))["emailId"]);
      formData.append('document', $('#inputCustomEntity')[0].files[0]);
      // var uploadTimer = setInterval(function () {
      //   clearTimeout(uploadTimer);
      $.ajax({
        url: '/api/custom-entity-import',
        method: "POST",
        type: "POST",
        data: formData,
        cache: false,
        contentType: false,
        processData: false,
        headers: {
          Authorization: "Bearer " + localStorage.getItem("access_token"),
        },
        xhr: function () {
          var xhr = new window.XMLHttpRequest();
          //Upload progress
          xhr.upload.addEventListener(
            "progress",
            function (evt) {
              if (evt.lengthComputable) {
                var percentComplete = Math.floor(
                  (evt.loaded / evt.total) * 100
                );
                importExportController.state.custEntPercentage = percentComplete;
                importExportController.setState(importExportController);
                console.log("Current percentage", percentComplete);
              }
            },
            false
          );
          return xhr;
        },
        success: function (data) {
          if (data.success === true) {
            // window.importCustomEntiStatusTimeoutHandle = setInterval(function () {
            //   importExportController.custEntityImportStatusApi(data.result);
            // }, 1000);
            importExportController.notifySuccessToast("Importing Custom Entity initiated");
            importExportController.state.customEntuProgress = true;
            importExportController.setState(this);
          } else {
            clearTimeout(window.importCustomEntiStatusTimeoutHandle);
            importExportController.notifyErrorToast(data.result);
            importExportController.state.customEntuProgress = true;
            importExportController.state.custEntityStatus = "error";
            importExportController.state.custEntPercentage = 100;
            importExportController.setState(importExportController.state);
          }
        },
        error: function (xhr) {
          if (xhr.status == 401) {
            window.location.href = "/platform/";
          }
        }
      });
      // }, 2000);
    }
  }

  uploadDialogDirectiveApi = () => {
    if ($('#inputDialogDirective')[0].files[0] == undefined) {
      this.notifyFileNotPresent("Please choose Incoming Dialog Directive file before import");

    } else if ($('#inputDialogDirective')[0].files[0].size >= 52428800) {
      this.notifyFileNotPresent("Size of the file exceeds its maximum permitted size of 52428800 bytes");
      this.state.dialogDirectiveProgress = true;
      this.setState(this.state);
    } else if (this.state.domainId == null) {
      this.notifyFileNotPresent("Please select domain");

    } else if (this.state.languageId == null) {
      this.notifyFileNotPresent("Please select language");
    } else {
      this.state.hideDialogDirectiveChooseFile = true;
      this.state.dialogDirectiveProgress = false;
      this.setState(this.state);
      var importExportController = this;
      var formData = new FormData();
      formData.append("projectIdString", localStorage.getItem("currentProjectId"));
      formData.append("domainIdString", this.state.domainId);
      formData.append("language", this.state.languageId);
      formData.append("contentType", "INCOMING_DIALOG_DIRECTIVE");
      formData.append("uploadedBy", JSON.parse(localStorage.getItem("user_details"))["emailId"]);
      formData.append('document', $('#inputDialogDirective')[0].files[0]);
      // var uploadTimer = setInterval(function () {
      //   clearTimeout(uploadTimer);
      $.ajax({
        url: '/api/dialog-directive-import',
        method: "POST",
        type: "POST",
        data: formData,
        cache: false,
        contentType: false,
        processData: false,
        headers: {
          Authorization: "Bearer " + localStorage.getItem("access_token"),
        },
        xhr: function () {
          var xhr = new window.XMLHttpRequest();
          //Upload progress
          xhr.upload.addEventListener(
            "progress",
            function (evt) {
              if (evt.lengthComputable) {
                var percentComplete = Math.floor(
                  (evt.loaded / evt.total) * 100
                );
                importExportController.state.dialogDirectivePercentage = percentComplete;
                importExportController.setState(importExportController);
                console.log("Current percentage", percentComplete);
              }
            },
            false
          );
          return xhr;
        },
        success: function (data) {
          if (data.success === true) {
            // window.importDialogDStatusTimeoutHandle = setInterval(function () {
            //   importExportController.dialogDirectiveImportStatusApi(data.result);
            // }, 1000);
            importExportController.notifySuccessToast("Importing Incoming Dialog Directive initiated");
            importExportController.state.dialogDirectiveProgress = true;
            importExportController.setState(this);
          } else {
            clearTimeout(window.importDialogDStatusTimeoutHandle);
            importExportController.notifyErrorToast(data.result);
            importExportController.state.dialogDirectiveProgress = true;
            importExportController.state.dialogDirectiveStatus = "error";
            importExportController.state.dialogDirectivePercentage = 100;
            importExportController.setState(importExportController.state);
          }
        },
        error: function (xhr) {
          if (xhr.status == 401) {
            window.location.href = "/platform/";
          }
        }
      });
      // }, 2000);
    }
  }

  uploadOutputDDApi = () => {
    if ($('#outputDDFile')[0].files[0] == undefined) {
      this.notifyFileNotPresent("Please choose Outgoing Dialog Directive file before import");

    } else if ($('#outputDDFile')[0].files[0].size >= 52428800) {
      this.notifyFileNotPresent("Size of the file exceeds its maximum permitted size of 52428800 bytes");
      this.state.outputDDProgress = true;
      this.setState(this.state);
    } else if (this.state.domainId == null) {
      this.notifyFileNotPresent("Please select domain");

    } else if (this.state.languageId == null) {
      this.notifyFileNotPresent("Please select language");
    } else {
      this.state.hideOutputDDChooseFile = true;
      this.state.outputDDProgress = false;
      this.setState(this.state);
      var importExportController = this;
      var formData = new FormData();
      formData.append("projectIdString", localStorage.getItem("currentProjectId"));
      formData.append("domainIdString", this.state.domainId);
      formData.append("language", this.state.languageId);
      formData.append("contentType", "OUTGOING_DIALOG_DIRECTIVE");
      formData.append("uploadedBy", JSON.parse(localStorage.getItem("user_details"))["emailId"]);
      formData.append('document', $('#outputDDFile')[0].files[0]);
      // var uploadTimer = setInterval(function () {
      //   clearTimeout(uploadTimer);
      $.ajax({
        url: '/api/output-dialog-directive-upload',
        method: "POST",
        type: "POST",
        data: formData,
        cache: false,
        contentType: false,
        processData: false,
        headers: {
          Authorization: "Bearer " + localStorage.getItem("access_token"),
        },
        xhr: function () {
          var xhr = new window.XMLHttpRequest();
          //Upload progress
          xhr.upload.addEventListener(
            "progress",
            function (evt) {
              if (evt.lengthComputable) {
                var percentComplete = Math.floor(
                  (evt.loaded / evt.total) * 100
                );
                importExportController.state.outputDDPercentage = percentComplete;
                importExportController.setState(importExportController);
                console.log("Current percentage", percentComplete);
              }
            },
            false
          );
          return xhr;
        },
        success: function (data) {
          if (data.success === true) {
            // window.importOutputDDStatusTimeoutHandle = setInterval(function () {
            //   importExportController.ouputDDImportStatusApi(data.result);
            // }, 1000);
            importExportController.notifySuccessToast("Importing Outgoing Dialog Directive initiated");
            importExportController.state.outputDDProgress = true;
            importExportController.setState(importExportController.state);
          } else {
            clearTimeout(window.importOutputDDStatusTimeoutHandle);
            importExportController.notifyErrorToast(data.result);
            importExportController.state.outputDDProgress = true;
            importExportController.state.outputDDStatus = "error";
            importExportController.state.outputDDPercentage = 100;
            importExportController.setState(importExportController.state);
          }
        },
        error: function (xhr) {
          if (xhr.status == 401) {
            window.location.href = "/platform/";
          }
        }
      });
      // }, 2000);
    }
  }

  notifyFileType() {
    toast(<b>Please upload file having extensions .json only.</b>, {
      position: "top-center",
      color: "#007aff"

    });
  }

  downloadFaq = () => {
    var domainId = this.state.domainId;
    var language = this.state.languageId
    var importExportController = this;
    $.ajax(
      {
        url: "/api/download-faq",
        async: false,
        method: 'GET',
        data: {
          projectId: localStorage.getItem('currentProjectId'),
          domainId: domainId,
          language: language
        },
        headers: {
          'Authorization': "Bearer " + localStorage.getItem("access_token"),
          'Content-Type': 'application/json'
        },
        success: function (res) {
          if (res.success === true) {
            const fileName = res.result.fileName;
            const json = JSON.stringify(res.result.data, undefined, 4);
            const blob = new Blob([json], { type: 'application/json' });
            const href = URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = href;
            link.download = fileName;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
          } else {
            importExportController.notifyFailToCreate();
          }
        },
        error: function (xhr) {
          if (xhr.status == 401) {
            window.location.href = "/platform/";
          }
        }
      }
    );
  }

  downloadFaqAsXlsxApi = () => {
    var domainId = this.state.domainId;
    var language = this.state.languageId
    var importExportController = this;
    $.ajax(
      {
        url: "/api/download-faq-xlsx",
        async: false,
        method: 'GET',
        data: {
          projectId: localStorage.getItem('currentProjectId'),
          domainId: domainId,
          language: language
        },
        headers: {
          'Authorization': "Bearer " + localStorage.getItem("access_token"),
          'Content-Type': 'application/json'
        },
        success: function (res) {
          const b64Data = res.result.data;
          const blob = importExportController.b64toBlob(b64Data, 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8', 512)
          let link = document.createElement('a');
          link.href = window.URL.createObjectURL(blob);
          link.download = res.result.fileName;
          document.body.appendChild(link);
          link.click();
        },
        error: function (xhr) {
          if (xhr.status == 401) {
            window.location.href = "/platform/";
          }
        }
      }
    );
  }

  b64toBlob = (b64Data, contentType, sliceSize) => {
    const byteCharacters = atob(b64Data);
    const byteArrays = [];

    for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
      const slice = byteCharacters.slice(offset, offset + sliceSize);

      const byteNumbers = new Array(slice.length);
      for (let i = 0; i < slice.length; i++) {
        byteNumbers[i] = slice.charCodeAt(i);
      }

      const byteArray = new Uint8Array(byteNumbers);
      byteArrays.push(byteArray);
    }

    const blob = new Blob(byteArrays, { type: contentType });
    return blob;
  }

  downloadSlusApi = () => {
    var domainId = this.state.domainId;
    var importExportController = this;
    $.ajax(
      {
        url: "/api/download-slu",
        async: false,
        method: 'GET',
        data: {
          projectId: localStorage.getItem('currentProjectId'),
          domainId: domainId
        },
        headers: {
          'Authorization': "Bearer " + localStorage.getItem("access_token"),
          'Content-Type': 'application/json'
        },
        success: function (res) {
          if (res.success === true) {
            const fileName = res.result.fileName;
            const json = JSON.stringify(res.result.data, undefined, 4);
            const blob = new Blob([json], { type: 'application/json' });
            const href = URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = href;
            link.download = fileName;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
          } else {
            importExportController.notifyFailToCreate();
          }
        },
        error: function (xhr) {
          if (xhr.status == 401) {
            window.location.href = "/platform/";
          }
        }
      }
    );
  }

  downloadMltApi = () => {
    var language = this.state.languageId
    var importExportController = this;
    $.ajax(
      {
        url: "/api/mlt-download",
        async: false,
        method: 'GET',
        data: {
          projectId: localStorage.getItem('currentProjectId'),
          language: language
        },
        headers: {
          'Authorization': "Bearer " + localStorage.getItem("access_token"),
          'Content-Type': 'application/json'
        },
        success: function (res) {
          if (res.success === true) {
            const fileName = res.result.fileName;
            const json = JSON.stringify(res.result.data, undefined, 4);
            const blob = new Blob([json], { type: 'application/json' });
            const href = URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = href;
            link.download = fileName;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
          } else {
            importExportController.notifyFailToCreate();
          }
        },
        error: function (xhr) {
          if (xhr.status == 401) {
            window.location.href = "/platform/";
          }
        }
      }
    );
  }

  downloadBackendApi = () => {
    var importExportController = this;
    $.ajax(
      {
        url: "/api/task-api/download",
        async: false,
        method: 'GET',
        data: {
          projectId: localStorage.getItem('currentProjectId'),
        },
        headers: {
          'Authorization': "Bearer " + localStorage.getItem("access_token"),
          'Content-Type': 'application/json'
        },
        success: function (res) {
          if (res.success === true) {
            const fileName = res.result.fileName;
            const json = JSON.stringify(res.result.data, undefined, 4);
            const blob = new Blob([json], { type: 'application/json' });
            const href = URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = href;
            link.download = fileName;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
          } else {
            importExportController.notifyFailToCreate();
          }
        },
        error: function (xhr) {
          if (xhr.status == 401) {
            window.location.href = "/platform/";
          }
        }
      }
    );
  }

  downloadEntitiesApi = () => {
    var language = this.state.languageId
    var importExportController = this;
    $.ajax(
      {
        url: "/api/download-multi-lingual-client-data",
        async: false,
        method: 'GET',
        data: {
          projectId: localStorage.getItem('currentProjectId'),
          language: language
        },
        headers: {
          'Authorization': "Bearer " + localStorage.getItem("access_token"),
          'Content-Type': 'application/json'
        },
        success: function (res) {
          if (res.success === true) {
            const fileName = res.result.fileName;
            const json = JSON.stringify(res.result.data, undefined, 4);
            const blob = new Blob([json], { type: 'application/json' });
            const href = URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = href;
            link.download = fileName;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
          } else {
            importExportController.notifyFailToCreate();
          }
        },
        error: function (xhr) {
          if (xhr.status == 401) {
            window.location.href = "/platform/";
          }
        }
      }
    );
  }

  downloadSubsApi = () => {
    var language = this.state.languageId
    var importExportController = this;
    $.ajax(
      {
        url: "/api/subs-download",
        async: false,
        method: 'GET',
        data: {
          projectId: localStorage.getItem('currentProjectId'),
          language: language
        },
        headers: {
          'Authorization': "Bearer " + localStorage.getItem("access_token"),
          'Content-Type': 'application/json'
        },
        success: function (res) {
          if (res.success === true) {
            const fileName = res.result.fileName;
            const json = JSON.stringify(res.result.data, undefined, 4);
            const blob = new Blob([json], { type: 'application/json' });
            const href = URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = href;
            link.download = fileName;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
          } else {
            importExportController.notifyFailToCreate();
          }
        },
        error: function (xhr) {
          if (xhr.status == 401) {
            window.location.href = "/platform/";
          }
        }
      }
    );
  }


  downloadCustEntiApi = () => {
    var language = this.state.languageId
    var importExportController = this;
    $.ajax(
      {
        url: "/api/download-custom-entity",
        async: false,
        method: 'GET',
        data: {
          projectId: localStorage.getItem('currentProjectId')
        },
        headers: {
          'Authorization': "Bearer " + localStorage.getItem("access_token"),
          'Content-Type': 'application/json'
        },
        success: function (res) {
          if (res.success === true) {
            const fileName = res.result.fileName;
            const json = JSON.stringify(res.result.data, undefined, 4);
            const blob = new Blob([json], { type: 'application/json' });
            const href = URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = href;
            link.download = fileName;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
          } else {
            importExportController.notifyFailToCreate();
          }
        },
        error: function (xhr) {
          if (xhr.status == 401) {
            window.location.href = "/platform/";
          }
        }
      }
    );
  }
  downloadLangSpecEntitiesApi = () => {
    var language = this.state.languageId
    var domainId = this.state.domainId;
    var importExportController = this;
    $.ajax(
      {
        url: "/api/nlp-api/download-named-entity",
        async: false,
        method: 'GET',
        data: {
          projectId: localStorage.getItem('currentProjectId'),
          domainId: domainId,
          language: language
        },
        headers: {
          'Authorization': "Bearer " + localStorage.getItem("access_token"),
          'Content-Type': 'application/json'
        },
        success: function (res) {
          if (res.success === true) {
            const fileName = res.result.fileName;
            const json = JSON.stringify(res.result.data, undefined, 4);
            const blob = new Blob([json], { type: 'application/json' });
            const href = URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = href;
            link.download = fileName;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
          } else {
            importExportController.notifyFailToCreate();
          }
        },
        error: function (xhr) {
          if (xhr.status == 401) {
            window.location.href = "/platform/";
          }
        }
      }
    );
  }

  downloadDialogDirectiveApi = () => {
    var language = this.state.languageId
    var importExportController = this;
    $.ajax(
      {
        url: "/api/download-dialog",
        async: false,
        method: 'GET',
        data: {
          projectId: localStorage.getItem('currentProjectId'),
          language: language
        },
        headers: {
          'Authorization': "Bearer " + localStorage.getItem("access_token"),
          'Content-Type': 'application/json'
        },
        success: function (res) {
          if (res.success === true) {
            const fileName = res.result.fileName;
            const json = JSON.stringify(res.result.data, undefined, 4);
            const blob = new Blob([json], { type: 'application/json' });
            const href = URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = href;
            link.download = fileName;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
          } else {
            importExportController.notifyFailToCreate();
          }
        },
        error: function (xhr) {
          if (xhr.status == 401) {
            window.location.href = "/platform/";
          }
        }
      }
    );
  }

  downloadOutputDDApi = () => {
    var language = this.state.languageId
    var importExportController = this;
    $.ajax(
      {
        url: "/api/download-output-dialog",
        async: false,
        method: 'GET',
        data: {
          projectId: localStorage.getItem('currentProjectId'),
          language: language
        },
        headers: {
          'Authorization': "Bearer " + localStorage.getItem("access_token"),
          'Content-Type': 'application/json'
        },
        success: function (res) {
          if (res.success === true) {
            const fileName = res.result.fileName;
            const json = JSON.stringify(res.result.data, undefined, 4);
            const blob = new Blob([json], { type: 'application/json' });
            const href = URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = href;
            link.download = fileName;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
          } else {
            importExportController.notifyFailToCreate();
          }
        },
        error: function (xhr) {
          if (xhr.status == 401) {
            window.location.href = "/platform/";
          }
        }
      }
    );
  }

  fetchLanguagesApi = (projectId) => {
    if (!projectId) {
      projectId = this.projectId;
      if (!projectId) {
        projectId = localStorage.getItem('currentProjectId');
      }
    }
    var languageController = this;
    var isLanguageInCurrentProject = false;
    $.ajax(
      {
        url: "/api/project-languages-selected",
        async: false,
        method: 'GET',
        data: {
          projectId: projectId,
        },
        headers: {
          'Authorization': "Bearer " + localStorage.getItem("access_token"),
          'Content-Type': 'application/json'
        },
        success: function (res) {
          if (res.success === true) {
            var loadlanguage = res.result;
          }
          else {
            languageController.notifyFailToLoadLanguages();
          }

          for (var i = 0; i < loadlanguage.length; i++) {
            if (localStorage.getItem("languageId") !== undefined &&
              loadlanguage[i]["code"] === localStorage.getItem("languageId")) {
              isLanguageInCurrentProject = true;
            }
            languageController.faqLoadLanguages.push({ 'value': loadlanguage[i]['code'], 'label': loadlanguage[i]['name'] })
          }

          if (languageController.props.location.state !== undefined) {
            if (isLanguageInCurrentProject) {
              languageController.state.selectedLanguageValue = localStorage.getItem("name");
              languageController.state.languageId = localStorage.getItem("languageId");
            } else {
              languageController.state.selectedLanguageValue = languageController.faqLoadLanguages[0].label;
              languageController.state.languageId = loadlanguage[0]["code"];
            }
          } else {
            languageController.state.selectedLanguageValue = languageController.faqLoadLanguages[0].label;
            languageController.state.languageId = loadlanguage[0]["code"];
          }

        },
        error: function (xhr) {
          if (xhr.status == 401) {
            window.location.href = "/platform/";
          }
        }
      }
    )
  }
  faqImportStatusApi = (id) => {
    let importExportController = this;
    $.ajax({
      url: "/api/faq-import-status",
      type: 'GET',
      async: false,
      headers: {
        "Authorization": "Bearer " + localStorage.getItem("access_token")
      },
      data: {
        documentId: id
      },
      success: function (res) {
        if (res.success === true) {
          res = res.result;
          importExportController.state.faqPercentage = res.percentage;
          if (res.percentage == 100) {
            clearTimeout(window.importStatusTimeoutHandle);
            importExportController.notifySuccessToast("FAQs imported successfully");
          } else if (res.status == 'ERROR') {
            importExportController.state.faqProgressStatus = "error";
            importExportController.state.faqPercentage = 100;
            importExportController.setState(importExportController.state);
            clearTimeout(window.importStatusTimeoutHandle);
          }
          importExportController.setState(importExportController.state);
        }
      },
      error: function (xhr) {
        if (xhr.status == 401) {
          window.location.href = "/";
        }
      }
    });
  }
  sluImportStatusApi = (id) => {
    let importExportController = this;
    $.ajax({
      url: "/api/slu-import-status",
      type: 'GET',
      async: false,
      headers: {
        "Authorization": "Bearer " + localStorage.getItem("access_token")
      },
      data: {
        documentId: id
      },
      success: function (res) {
        if (res.success === true) {
          res = res.result;
          importExportController.state.sluPercentage = res.percentage;
          if (res.percentage == 100) {
            clearTimeout(window.importSluStatusTimeoutHandle);
            importExportController.notifySuccessToast("Intents & Automations imported successfully");
          } else if (res.status == 'ERROR') {
            importExportController.state.sluProgressStatus = "error";
            importExportController.state.sluPercentage = 100;
            importExportController.setState(importExportController.state);
            clearTimeout(window.importSluStatusTimeoutHandle);
          }
          importExportController.setState(importExportController.state);
        }
      },
      error: function (xhr) {
        if (xhr.status == 401) {
          window.location.href = "/";
        }
      }
    });
  }
  mltImportStatusApi = (id) => {
    let importExportController = this;
    $.ajax({
      url: "/api/mlt-import-status",
      type: 'GET',
      async: false,
      headers: {
        "Authorization": "Bearer " + localStorage.getItem("access_token")
      },
      data: {
        documentId: id
      },
      success: function (res) {
        if (res.success === true) {
          res = res.result;
          importExportController.state.mltPercentage = res.percentage;
          if (res.percentage == 100) {
            clearTimeout(window.importMltStatusTimeoutHandle);
            importExportController.notifySuccessToast("Automation Responses imported successfully");
          } else if (res.status == 'ERROR') {
            importExportController.state.mltProgressStatus = "error";
            importExportController.state.mltPercentage = 100;
            importExportController.setState(importExportController.state);
            clearTimeout(window.importMltStatusTimeoutHandle);
          }
          importExportController.setState(importExportController.state);
        }
      },
      error: function (xhr) {
        if (xhr.status == 401) {
          window.location.href = "/";
        }
      }
    });
  }
  backendApiImportStatusApi = (id) => {
    let importExportController = this;
    $.ajax({
      url: "/api/backend-api-import-status",
      type: 'GET',
      async: false,
      headers: {
        "Authorization": "Bearer " + localStorage.getItem("access_token")
      },
      data: {
        documentId: id
      },
      success: function (res) {
        if (res.success === true) {
          res = res.result;
          importExportController.state.apiPercentage = res.percentage;
          if (res.percentage == 100) {
            clearTimeout(window.importBackendApiStatusTimeoutHandle);
            importExportController.notifySuccessToast("Backend APIs imported successfully");
          } else if (res.status == 'ERROR') {
            importExportController.state.apiProgressStatus = "error";
            importExportController.state.apiPercentage = 100;
            importExportController.setState(importExportController.state);
            clearTimeout(window.importBackendApiStatusTimeoutHandle);
          }
          importExportController.setState(importExportController.state);
        }
      },
      error: function (xhr) {
        if (xhr.status == 401) {
          window.location.href = "/";
        }
      }
    });
  }
  entitiesImportStatusApi = (id) => {
    let importExportController = this;
    $.ajax({
      url: "/api/mlcd-import-status",
      type: 'GET',
      async: false,
      headers: {
        "Authorization": "Bearer " + localStorage.getItem("access_token")
      },
      data: {
        documentId: id
      },
      success: function (res) {
        if (res.success === true) {
          res = res.result;
          importExportController.state.mlcdPercentage = res.percentage;
          if (res.percentage == 100) {
            clearTimeout(window.importEntitiesStatusTimeoutHandle);
            importExportController.notifySuccessToast("Multilingual Entities imported successfully");
          } else if (res.status == 'ERROR') {
            importExportController.state.mlcdProgressStatus = "error";
            importExportController.state.mlcdPercentage = 100;
            importExportController.setState(importExportController.state);
            clearTimeout(window.importEntitiesStatusTimeoutHandle);
          }
          importExportController.setState(importExportController.state);
        }
      },
      error: function (xhr) {
        if (xhr.status == 401) {
          window.location.href = "/";
        }
      }
    });
  }
  languageSpecificEntitiesImportStatusApi = (id) => {
    let importExportController = this;
    $.ajax({
      url: "/api/named-entity-import-status",
      type: 'GET',
      async: false,
      headers: {
        "Authorization": "Bearer " + localStorage.getItem("access_token")
      },
      data: {
        documentId: id
      },
      success: function (res) {
        if (res.success === true) {
          res = res.result;
          importExportController.state.nePercentage = res.percentage;
          if (res.percentage == 100) {
            clearTimeout(window.importLangSpecEntitesStatusTimeoutHandle);
            importExportController.notifySuccessToast("Language Specific Entities imported successfully");
          } else if (res.status == 'ERROR') {
            importExportController.state.neProgressStatus = "error";
            importExportController.state.nePercentage = 100;
            importExportController.setState(importExportController.state);
            clearTimeout(window.importLangSpecEntitesStatusTimeoutHandle);
          }
          importExportController.setState(importExportController.state);
        }
      },
      error: function (xhr) {
        if (xhr.status == 401) {
          window.location.href = "/";
        }
      }
    });
  }
  subsImportStatusApi = (id) => {
    let importExportController = this;
    $.ajax({
      url: "/api/subs-import-status",
      type: 'GET',
      async: false,
      headers: {
        "Authorization": "Bearer " + localStorage.getItem("access_token")
      },
      data: {
        documentId: id
      },
      success: function (res) {
        if (res.success === true) {
          res = res.result;
          importExportController.state.subPercentage = res.percentage;
          if (res.percentage == 100) {
            clearTimeout(window.importSubsStatusTimeoutHandle);
            importExportController.notifySuccessToast("Substitutions imported successfully");
          } else if (res.status == 'ERROR') {
            importExportController.state.subsProgressStatus = "error";
            importExportController.state.subPercentage = 100;
            importExportController.setState(importExportController.state);
            clearTimeout(window.importSubsStatusTimeoutHandle);
          }
          importExportController.setState(importExportController.state);
        }
      },
      error: function (xhr) {
        if (xhr.status == 401) {
          window.location.href = "/";
        }
      }
    });
  }

  custEntityImportStatusApi = (id) => {
    let importExportController = this;
    $.ajax({
      url: "/api/custom-entity-import-status",
      type: 'GET',
      async: false,
      headers: {
        "Authorization": "Bearer " + localStorage.getItem("access_token")
      },
      data: {
        documentId: id
      },
      success: function (res) {
        if (res.success === true) {
          res = res.result;
          importExportController.state.custEntPercentage = res.percentage;
          if (res.percentage == 100) {
            clearTimeout(window.importCustomEntiStatusTimeoutHandle);
            importExportController.notifySuccessToast("Custom Entities imported successfully");
          } else if (res.status == 'ERROR') {
            importExportController.state.customEntuProgress = "error";
            importExportController.state.custEntPercentage = 100;
            importExportController.setState(importExportController.state);
            clearTimeout(window.importCustomEntiStatusTimeoutHandle);
          }
          importExportController.setState(importExportController.state);
        }
      },
      error: function (xhr) {
        if (xhr.status == 401) {
          window.location.href = "/";
        }
      }
    });
  }
  dialogDirectiveImportStatusApi = (id) => {
    let importExportController = this;
    $.ajax({
      url: "/api/dialog-directive-import-status",
      type: 'GET',
      async: false,
      headers: {
        "Authorization": "Bearer " + localStorage.getItem("access_token")
      },
      data: {
        documentId: id
      },
      success: function (res) {
        if (res.success === true) {
          res = res.result;
          importExportController.state.dialogDirectivePercentage = res.percentage;
          if (res.percentage == 100) {
            clearTimeout(window.importDialogDStatusTimeoutHandle);
            importExportController.notifySuccessToast("Incoming Dialog Directive imported successfully");
          } else if (res.status == 'ERROR') {
            importExportController.state.dialogDirectiveProgress = "error";
            importExportController.state.dialogDirectivePercentage = 100;
            importExportController.setState(importExportController.state);
            clearTimeout(window.importDialogDStatusTimeoutHandle);
          }
          importExportController.setState(importExportController.state);
        }
      },
      error: function (xhr, status, error) {
        if (xhr.status == 401) {
          window.location.href = "/";
        }
      }
    });
  }
  ouputDDImportStatusApi = (id) => {
    let importExportController = this;
    $.ajax({
      url: "/api/dmoutput-import-status",
      type: 'GET',
      async: false,
      headers: {
        "Authorization": "Bearer " + localStorage.getItem("access_token")
      },
      data: {
        documentId: id
      },
      success: function (res) {
        if (res.success === true) {
          res = res.result;
          importExportController.state.outputDDPercentage = res.percentage;
          if (res.percentage == 100) {
            clearTimeout(window.importOutputDDStatusTimeoutHandle);
            importExportController.notifySuccessToast("Outgoing Dialog Directive imported successfully");
          } else if (res.status == 'ERROR') {
            importExportController.state.outputDDStatus = "error";
            importExportController.state.outputDDPercentage = 100;
            importExportController.setState(importExportController.state);
            clearTimeout(window.importOutputDDStatusTimeoutHandle);
          }
          importExportController.setState(importExportController.state);
        }
      },
      error: function (xhr) {
        if (xhr.status == 401) {
          window.location.href = "/";
        }
      }
    });
  }
  refreshData = () => {
    var importExportController = this;
    importExportController.state.faqhideChoseFile = false;
    importExportController.state.faqAsXlsxHideChoseFile = false;
    importExportController.state.sluhideChoseFile = false;
    importExportController.state.sluProgress = true;
    importExportController.state.apihideChoseFile = false;
    importExportController.state.mlthideChoseFile = false;
    importExportController.state.entityhideChoseFile = false;
    importExportController.state.langSpecihideChoseFile = false;
    importExportController.state.subshideChoseFile = false;
    importExportController.state.custEntihideChoseFile = false;
    importExportController.state.hideDialogDirectiveChooseFile = false
    importExportController.state.hideOutputDDChooseFile = false;
    importExportController.state.hideAbbTextChooseFile = false;
    importExportController.setState(importExportController.state);

    if (document.getElementById("inputFaqAsXlsxFile") != null) {
      document.getElementById("inputFaqAsXlsxFile").value = null;
      document.getElementById("inputFaqFile").value = null;
      document.getElementById("inputSluFile").value = null;
      document.getElementById("inputMltFile").value = null;
      document.getElementById("inputBackendApiFile").value = null;
      document.getElementById("inputEntityFile").value = null;
      document.getElementById("inputLangSpecificEntityFile").value = null;
      document.getElementById("inputSubsFile").value = null;
      document.getElementById("inputCustomEntity").value = null;
      document.getElementById("inputDialogDirective").value = null;
      document.getElementById("outputDDFile").value = null;
      document.getElementById("abbreviationText").value = null;
    }

    clearTimeout(window.importStatusTimeoutHandle);
    clearTimeout(window.importSluStatusTimeoutHandle);
    clearTimeout(window.importMltStatusTimeoutHandle);
    clearTimeout(window.importBackendApiStatusTimeoutHandle);
    clearTimeout(window.importEntitiesStatusTimeoutHandle);
    clearTimeout(window.importLangSpecEntitesStatusTimeoutHandle);
    clearTimeout(window.importSubsStatusTimeoutHandle);
    clearTimeout(window.importCustomEntiStatusTimeoutHandle);
    clearTimeout(window.importDialogDStatusTimeoutHandle);
    clearTimeout(window.importOutputDDStatusTimeoutHandle);
    clearTimeout(window.abbTextStatusTimeoutHandle);
  }

  downloadAbbreviationApi = () => {
    var language = this.state.languageId
    var importExportController = this;
    $.ajax(
      {
        url: "/api/abbreviation/text/download",
        async: false,
        method: 'GET',
        data: {
          projectId: localStorage.getItem('currentProjectId'),
          language: language
        },
        headers: {
          'Authorization': "Bearer " + localStorage.getItem("access_token"),
          'Content-Type': 'application/json'
        },
        success: function (res) {
          if (res.success === true) {
            const fileName = res.result.fileName;
            const json = JSON.stringify(res.result.data, undefined, 4);
            const blob = new Blob([json], { type: 'application/json' });
            const href = URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = href;
            link.download = fileName;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
          } else {
            importExportController.notifyFailToCreate();
          }
        },
        error: function (xhr) {
          if (xhr.status == 401) {
            window.location.href = "/platform/";
          }
        }
      }
    );
  }

  uploadAbbreviationApi = () => {
    if ($('#abbreviationText')[0].files[0] == undefined) {
      this.notifyFileNotPresent("Please choose Abbreviation Text file before import");

    } else if ($('#abbreviationText')[0].files[0].size >= 52428800) {
      this.notifyFileNotPresent("Size of the file exceeds its maximum permitted size of 52428800 bytes");
      this.state.disableAbbreviationImport = true;
      this.setState(this.state);
    } else if (this.state.domainId == null) {
      this.notifyFileNotPresent("Please select domain");

    } else if (this.state.languageId == null) {
      this.notifyFileNotPresent("Please select language");
    } else {
      this.state.hideAbbTextChooseFile = true;
      this.state.disableAbbreviationImport = false;
      this.setState(this.state);
      var importExportController = this;
      var formData = new FormData();
      formData.append("projectIdString", localStorage.getItem("currentProjectId"));
      formData.append("domainIdString", this.state.domainId);
      formData.append("language", this.state.languageId);
      formData.append("contentType", "OUTGOING_DIALOG_DIRECTIVE");
      formData.append("uploadedBy", JSON.parse(localStorage.getItem("user_details"))["emailId"]);
      formData.append('document', $('#abbreviationText')[0].files[0]);
      // var uploadTimer = setInterval(function () {
      //   clearTimeout(uploadTimer);
      $.ajax({
        url: '/api/abbreviation-upload',
        method: "POST",
        type: "POST",
        data: formData,
        cache: false,
        contentType: false,
        processData: false,
        headers: {
          Authorization: "Bearer " + localStorage.getItem("access_token"),
        },
        xhr: function () {
          var xhr = new window.XMLHttpRequest();
          //Upload progress
          xhr.upload.addEventListener(
            "progress",
            function (evt) {
              if (evt.lengthComputable) {
                var percentComplete = Math.floor(
                  (evt.loaded / evt.total) * 100
                );
                importExportController.state.abbreviationUploadPercentage = percentComplete;
                importExportController.setState(importExportController);
                console.log("Current percentage", percentComplete);
              }
            },
            false
          );
          return xhr;
        },
        success: function (data) {
          if (data.success === true) {
            // window.abbTextStatusTimeoutHandle = setInterval(function () {
            //   importExportController.abbreviationImportStatusApi(data.result);
            // }, 1000);
            importExportController.notifySuccessToast("Importing Abbreviation Text initiated");
            importExportController.state.disableAbbreviationImport = true;
            importExportController.setState(this);
          } else {
            clearTimeout(window.abbTextStatusTimeoutHandle);
            importExportController.notifyErrorToast(data.result);
            importExportController.state.disableAbbreviationImport = true;
            importExportController.state.abbreviationUploadStatus = "error";
            importExportController.state.abbreviationUploadPercentage = 100;
            importExportController.setState(importExportController.state);
          }
        },
        error: function (xhr) {
          if (xhr.status == 401) {
            window.location.href = "/platform/";
          } else if (xhr.status == 500) {
            clearTimeout(window.abbTextStatusTimeoutHandle);
            importExportController.notifyFailToCreate();
            importExportController.state.disableAbbreviationImport = true;
            importExportController.state.abbreviationUploadStatus = "error";
            importExportController.state.abbreviationUploadPercentage = 100;
            importExportController.setState(importExportController.state);
          }
        }
      });
      // }, 2000);
    }
  }

  abbreviationImportStatusApi = (id) => {
    let importExportController = this;
    $.ajax({
      url: "/api/abbreviation-import-status",
      type: 'GET',
      async: false,
      headers: {
        "Authorization": "Bearer " + localStorage.getItem("access_token")
      },
      data: {
        documentId: id
      },
      success: function (res) {
        if (res.success === true) {
          res = res.result;
          importExportController.state.abbreviationUploadPercentage = res.percentage;
          if (res.percentage == 100) {
            clearTimeout(window.abbTextStatusTimeoutHandle);
            importExportController.notifySuccessToast("Abbreviation imported successfully");
          } else if (res.status == 'ERROR') {
            importExportController.state.abbreviationUploadStatus = "error";
            importExportController.state.abbreviationUploadPercentage = 100;
            importExportController.setState(importExportController.state);
            clearTimeout(window.abbTextStatusTimeoutHandle);
          }
          importExportController.setState(importExportController.state);
        }
      },
      error: function (xhr) {
        if (xhr.status == 401) {
          window.location.href = "/";
        }
      }
    });
  }
  render() {
    const selectedDomainOption = this.state.selectedDomainValue;
    const selectedLanguageOption = this.state.selectedLanguageValue;
    const { data } = this.state
    const columns1 = [

      {
        width: 250,
        Header: '',
        minWidth: 17,
        textAlign: 'screenLeft',
        accessor: 'text',
        sortable: false,
        cellStyle: { border: 'none' },
        headerStyle: { marginTop: '-10px' },
        Cell: props =>
        (

          <div class="card-body chat_body log_one">
            <div className={(props.original.incoming == false) ? "direct-chat-msg" : "direct-chat-msg right "}>
              <div className={(props.original.incoming == false) ? "direct-chat-text chat_left textarea" : "direct-chat-text chat_right textarea"}
                style={{
                  display: props.original.id != "" || props.original.id != undefined ||
                    props.original.id != null ? "block" : "none",
                  marginTop: "5px", width: "200%", height: "auto",
                  backgroundColor: props.original.incoming == false ? "#ead5d5" : "#e1e1f5",
                  marginTop: '-10px', borderBottom: 'none',
                  textAlign: props.original.incoming == false ? "left" : "right",
                }}>

                <font
                  id={"text" + props.index}
                  readOnly={(props.original.id != "") ? props.original.id != this.state.editedId : false}>{props.original.text}
                </font>
              </div></div>
          </div>

        )
      },
    ]
    //------------------------------------------------------------------------------------------------------   



    return (
      <div visible={(this.state.successResp) ? false : true}>
        <div style={{
          background: "#F9F9FB", marginLeft: '1%', marginRight: '1%'
        }}>
          {/* for toaster */}
          <link rel="stylesheet" href="assets/css/ReactToastify.css" />
          {/* for reactTable */}
          <link rel="stylesheet" href="assets/css/React_Table_CSS/react-table.css" />
          <link rel="stylesheet" href="./assets/css/react.table.border.css" />
          {/*for dialog component */}
          <link href="assets/css/ej2-base.css" rel="stylesheet" />
          <link href="assets/css/ej2-react-buttons.css" rel="stylesheet" />
          <link href="assets/css/ej2-react-popups.css" rel="stylesheet" />
          <link href="assets/css/ej2-inputs.css" rel="stylesheet" />
          <link href="assets/css/screenResolution.css" rel="stylesheet" />

          {/* <div className="wrapper"> */}
          <link rel="shortcut icon" type="image/png" href="assets/images/bot.ico" />
          <title> Dheeyantra | BackEnd Api </title>
          {/* Font Awesome Icons */}
          <link rel="stylesheet" href="plugins/font-awesome/css/font-awesome.min.css" />
          {/* IonIcons */}
          <link rel="stylesheet" href="//code.ionicframework.com/ionicons/2.0.1/css/ionicons.min.css" />
          <link rel="stylesheet" href="assets/fonts/flat-icon/flaticon.css" />
          {/* Theme style */}
          <link rel="stylesheet" href="assets/css/adminlte.css" />
          <link href="https://cdn.jsdelivr.net/npm/gijgo@1.9.6/css/gijgo.min.css" rel="stylesheet" />
          <link rel="stylesheet" href="plugins/select2/select2.min.css" />
          <link rel="stylesheet" href="assets/css/custom-style.css" />
          <link rel="stylesheet" href="assets/css/styles.css" />
          {/* ----new style------------------------------- */}
          <link rel="shortcut icon" type="image/png" href="assets/images/bot.ico" />
          <link rel="stylesheet" href="plugins/font-awesome/css/font-awesome.min.css" />
          <link rel="stylesheet" href="//code.ionicframework.com/ionicons/2.0.1/css/ionicons.min.css" />
          <link href="https://cdn.jsdelivr.net/npm/gijgo@1.9.6/css/gijgo.min.css" rel="stylesheet" />
          <link rel="stylesheet" href="assets/fonts/flat-icon/flaticon.css" />
          <link rel="stylesheet" href="plugins/select2/select2.min.css" />
          <link rel="stylesheet" href="dist/css/adminlte.css" />
          <link rel="stylesheet" href="assets/css/custom-style.css" />
          <link rel="stylesheet" href="assets/css/styles.css" />
          <style media="screen" dangerouslySetInnerHTML={{ __html: "\n    .card-footer {\n      background-color: transparent;\n      padding: 0.75rem 0.25rem;\n    }\n\n    .logtable tbody td:last-child{\n      width: 150px;\n    }\n\n    .logTableBox{\n      overflow: auto !important;\n    }\n  " }} />


          {/* for checkbox component */}
          <link rel="stylesheet" href="assets/css/Checkbox/Checkboxbutton.css" />
          <link rel="stylesheet" href="assets/css/Checkbox/CheckboxTick.css" />
          <link rel="stylesheet" href="./assets/css/combobox-style.css" />


          <div className="container-fluid">
            <div className="row">
              <div className="col-sm-4">


                <Select
                  value={this.faqLoadLanguages.filter(option => option.label === selectedLanguageOption)}
                  onChange={this.handleLangChange}
                  options={this.faqLoadLanguages} />
              </div>

              <div className="col-sm-4" style={{ marginBottom: '15px' }}>


                <Select
                  value={this.sluDomains.filter(option => option.label === selectedDomainOption)}
                  onChange={this.handleDomainChange}
                  options={this.sluDomains} />
              </div>
              <div className="col-sm-4" align="right">
                <button type="button" className="btn action-button" style={{ marginRight: "8%" }} title="refresh" onClick={this.refreshData}>
                  <img className="img-responsive cursor-change" src="./assets/images/refresh_white_24dp.png"></img>
                </button>
              </div>


              {/* Add button */}
              <div className="col-sm-5" Align='right'>



              </div>
            </div>
          </div>
          {/* /.content-header */}
          <div className="content">
            <div className="container-fluid" >
              <div className="row"
                style={{ marginRight: '2%' }}  >
                <div className="col-lg-7" >
                  <div className="card">
                    <div textAlign="center"  >
                      <h6 className="nav-item" style={{ color: '#282a65', marginTop: '20px', marginLeft: "10px", align: "center" }}>Import File</h6>
                    </div>
                    <br />
                    <div className="row">
                      <div className="row" align="center">
                        <div className="col-sm-6" >

                          <input type="file" id="inputFaqFile" title="Choose faq file"
                            style={{
                              color: "black", marginTop: "10px", marginLeft: "60px", width: "200px",
                              display: this.state.faqhideChoseFile ? 'none' : 'block'
                            }} />
                          <Progress
                            style={{
                              display: this.state.faqhideChoseFile ? 'block' : 'none', marginTop: "10px",
                              marginLeft: "60px", width: "200px"
                            }}
                            id="build"
                            width="500px"
                            height="50px"
                            rectBorderRadius="1px"
                            status={this.state.faqProgressStatus}
                            percent={this.state.faqPercentage}
                          />
                        </div>


                      </div>

                      <div className="col-sm-6" align="center">
                        <button className="btn action-button" style={{ width: "230px" }} onClick={this.uploadFaqApi}
                          disabled={!this.state.faqButtonDiable}
                        >  Import FAQs</button></div>

                      <div className="row" align="center">
                        <div className="col-sm-6" >
                          <input type="file"
                            id="inputFaqAsXlsxFile"
                            title="Choose faq file"
                            accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, .csv"
                            style={{
                              color: "black", marginTop: "10px", marginLeft: "60px", width: "200px",
                              display: this.state.faqAsXlsxHideChoseFile ? 'none' : 'block'
                            }} />
                          <Progress
                            style={{
                              display: this.state.faqAsXlsxHideChoseFile ? 'block' : 'none', marginTop: "10px",
                              marginLeft: "60px", width: "200px"
                            }}
                            id="build"
                            width="500px"
                            height="50px"
                            rectBorderRadius="1px"
                            status={this.state.faqAsXlsxProgressStatus}
                            percent={this.state.faqAsXlsxPercentage}
                          />
                        </div>
                      </div>
                      <div className="col-sm-6" align="center">
                        <button className="btn action-button" style={{ width: "230px" }} onClick={this.uploadFaqAsXlsxApi}
                          disabled={!this.state.faqAsXlsxButtonDiable}
                        >  Import FAQs as Xlsx</button></div>

                      <div className="row">
                        <div className="col-sm-6" align="center">
                          <input type="file" id="inputSluFile"
                            title="Choose intents and automation file"
                            style={{ color: "black", marginTop: "10px", marginLeft: "60px", width: "200px", display: this.state.sluhideChoseFile ? 'none' : 'block' }} />
                          <Progress
                            style={{
                              display: this.state.sluhideChoseFile ? 'block' : 'none', marginTop: "10px",
                              marginLeft: "60px", width: "200px"
                            }}
                            id="build"
                            width="500px"
                            height="50px"
                            rectBorderRadius="1px"
                            status={this.state.sluProgressStatus}
                            percent={this.state.sluPercentage}
                          />
                        </div>

                      </div>
                      <div className="col-sm-6" align="center">
                        <button className="btn action-button" style={{ width: "230px" }} onClick={this.uploadSluApi} disabled={!this.state.sluProgress}>  Import Intents &amp; Automations</button></div>

                      <div className="row">
                        <div className="col-sm-6" align="center">
                          <input type="file" id="inputMltFile" title="Choose a response file"
                            style={{ color: "black", marginTop: "10px", marginLeft: "60px", width: "200px", display: this.state.mlthideChoseFile ? 'none' : 'block' }} />

                          <Progress
                            style={{
                              display: this.state.mlthideChoseFile ? 'block' : 'none', marginTop: "10px",
                              marginLeft: "60px", width: "200px"
                            }}
                            id="build"
                            width="500px"
                            height="50px"
                            rectBorderRadius="1px"
                            status={this.state.mltProgressStatus}
                            percent={this.state.mltPercentage}
                          />

                        </div>
                      </div>
                      <div className="col-sm-6" align="center" >
                        <button className="btn action-button" style={{ width: "230px" }} onClick={this.uploadMltsApi} disabled={!this.state.mltProgress}>  Import Automation Responses</button></div>

                      <div className="row">
                        <div className="col-sm-6" align="center">
                          <input type="file" id="inputBackendApiFile" title="Choose a backend api file"
                            style={{ color: "black", marginTop: "10px", marginLeft: "60px", width: "200px", display: this.state.apihideChoseFile ? 'none' : 'block' }} />
                          <Progress
                            style={{
                              display: this.state.apihideChoseFile ? 'block' : 'none', marginTop: "10px",
                              marginLeft: "60px", width: "200px"
                            }}
                            id="build"
                            width="500px"
                            height="50px"
                            rectBorderRadius="1px"
                            status={this.state.apiProgressStatus}
                            percent={this.state.apiPercentage}
                          />
                        </div>
                      </div>
                      <div className="col-sm-6" align="center">
                        <button className="btn action-button" style={{ width: "230px" }}
                          onClick={this.uploadBackendApiApi} disabled={!this.state.backendApiProgress}>  Import Backend APIs</button></div>

                      <div className="row">
                        <div className="col-sm-6" align="center" >
                          <input type="file" id="inputEntityFile" title="Choose a multilingual entities file"
                            style={{ color: "black", marginTop: "10px", marginLeft: "60px", width: "200px", display: this.state.entityhideChoseFile ? 'none' : 'block' }} />
                          <Progress
                            style={{
                              display: this.state.entityhideChoseFile ? 'block' : 'none', marginTop: "10px",
                              marginLeft: "60px", width: "200px"
                            }}
                            id="build"
                            width="500px"
                            height="50px"
                            rectBorderRadius="1px"
                            status={this.state.mlcdProgressStatus}
                            percent={this.state.mlcdPercentage}
                          />

                        </div>
                      </div>
                      <div className="col-sm-6" align="center">
                        <button className="btn action-button" style={{ width: "230px" }}
                          onClick={this.uploadEntitiesApi} disabled={!this.state.mlcdProgress}>  Import Multilingual Entities</button></div>


                      <div className="row">
                        <div className="col-sm-6" align="center" >
                          <input type="file" id="inputLangSpecificEntityFile"
                            title="Choose a language specific entity file"
                            style={{ color: "black", marginTop: "10px", marginLeft: "60px", width: "200px", display: this.state.langSpecihideChoseFile ? 'none' : 'block' }} />
                          <Progress
                            style={{
                              display: this.state.langSpecihideChoseFile ? 'block' : 'none', marginTop: "10px",
                              marginLeft: "60px", width: "200px"
                            }}
                            id="build"
                            width="500px"
                            height="50px"
                            rectBorderRadius="1px"
                            status={this.state.neProgressStatus}
                            percent={this.state.nePercentage}
                          />
                        </div>
                      </div>
                      <div className="col-sm-6" align="center" >
                        <button className="btn action-button" style={{ width: "230px" }} onClick={this.uploadLangSpecificEntitiesApi}
                          disabled={!this.state.namedEntityProgress}>  Import Language Specific Entities</button></div>

                      <div className="row">
                        <div className="col-sm-6" align="center" >
                          <input type="file" id="inputSubsFile" title="Choose a substitution file"
                            style={{ color: "black", marginTop: "10px", marginLeft: "60px", width: "200px", display: this.state.subshideChoseFile ? 'none' : 'block' }} />
                          <Progress
                            style={{
                              display: this.state.subshideChoseFile ? 'block' : 'none', marginTop: "10px",
                              marginLeft: "60px", width: "200px"
                            }}
                            id="build"
                            width="500px"
                            height="50px"
                            rectBorderRadius="1px"
                            status={this.state.subsProgressStatus}
                            percent={this.state.subPercentage}
                          />

                        </div>
                      </div>
                      <div className="col-sm-6" align="center">
                        <button className="btn action-button" style={{ width: "230px" }}
                          onClick={this.uploadSubsApi} disabled={!this.state.subsProgress}>  Import Substitutions</button></div>


                      <div className="row">
                        <div className="col-sm-6" align="center" >
                          <input type="file" id="inputCustomEntity" title="Choose a Custom Entity file"
                            style={{ color: "black", marginTop: "10px", marginLeft: "60px", width: "200px", display: this.state.custEntihideChoseFile ? 'none' : 'block' }} />
                          <Progress
                            style={{
                              display: this.state.custEntihideChoseFile ? 'block' : 'none', marginTop: "10px",
                              marginLeft: "60px", width: "200px"
                            }}
                            id="build"
                            width="500px"
                            height="50px"
                            rectBorderRadius="1px"
                            status={this.state.custEntityStatus}
                            percent={this.state.custEntPercentage}
                          />

                        </div>
                      </div>
                      <div className="col-sm-6" align="center">
                        <button className="btn action-button" style={{ width: "230px" }}
                          onClick={this.uploadCustomEntiApi} disabled={!this.state.customEntuProgress}>  Import Custom Entity</button></div>


                      <div className="row">
                        <div className="col-sm-6" align="center" >
                          <input type="file" id="inputDialogDirective" title="Choose a Incoming Dialog Directive file"
                            style={{ color: "black", marginTop: "10px", marginLeft: "60px", width: "200px", display: this.state.hideDialogDirectiveChooseFile ? 'none' : 'block' }} />
                          <Progress
                            style={{
                              display: this.state.hideDialogDirectiveChooseFile ? 'block' : 'none', marginTop: "10px",
                              marginLeft: "60px", width: "200px"
                            }}
                            id="build"
                            width="500px"
                            height="50px"
                            rectBorderRadius="1px"
                            status={this.state.dialogDirectiveStatus}
                            percent={this.state.dialogDirectivePercentage}
                          />

                        </div>
                      </div>
                      <div className="col-sm-6" align="center">
                        <button className="btn action-button" style={{ width: "230px" }}
                          onClick={this.uploadDialogDirectiveApi} disabled={!this.state.dialogDirectiveProgress}>  Import Incoming Dialog Directive</button></div>

                      <div className="row">
                        <div className="col-sm-6" align="center" >
                          <input type="file" id="outputDDFile" title="Choose a Outgoing Dialog Directive file"
                            style={{ color: "black", marginTop: "10px", marginLeft: "60px", width: "200px", display: this.state.hideOutputDDChooseFile ? 'none' : 'block' }} />
                          <Progress
                            style={{
                              display: this.state.hideOutputDDChooseFile ? 'block' : 'none', marginTop: "10px",
                              marginLeft: "60px", width: "200px"
                            }}
                            id="build"
                            width="500px"
                            height="50px"
                            rectBorderRadius="1px"
                            status={this.state.outputDDStatus}
                            percent={this.state.outputDDPercentage}
                          />

                        </div>
                      </div>
                      <div className="col-sm-6" align="center">
                        <button className="btn action-button" style={{ width: "230px" }}
                          onClick={this.uploadOutputDDApi} disabled={!this.state.outputDDProgress}>  Import Outgoing Dialog Directive
                        </button>
                      </div>

                      <div className="row">
                        <div className="col-sm-6" align="center" >
                          <input type="file" id="abbreviationText" title="Choose a Abbreviation Text file"
                            style={{ color: "black", marginTop: "10px", marginLeft: "60px", width: "200px", display: this.state.hideAbbTextChooseFile ? 'none' : 'block' }}
                          />
                          <Progress
                            style={{
                              display: this.state.hideAbbTextChooseFile ? 'block' : 'none', marginTop: "10px",
                              marginLeft: "60px", width: "200px"
                            }}
                            id="build"
                            width="500px"
                            height="50px"
                            rectBorderRadius="1px"
                            status={this.state.abbreviationUploadStatus}
                            percent={this.state.abbreviationUploadPercentage}
                          />

                        </div>
                      </div>
                      <div className="col-sm-6" align="center">
                        <button className="btn action-button" style={{ width: "230px" }}
                          onClick={this.uploadAbbreviationApi} disabled={!this.state.disableAbbreviationImport}>Import Abbreviation Text</button>
                      </div>
                    </div>
                  </div>


                  <ToastContainer className="Toast-at-center" />
                  {/* Dialog Component For ADD Success */}
                  <DialogComponent width='250px' id="update"
                    animationSettings={this.settings} header='Success'
                    showCloseIcon={true} buttons={this.addedButton}
                    ref={dialog => this.dialogInstance = dialog}
                    visible={this.state.hideAddDialog} close={this.dialogClose}>
                    <img src="assets/images/done.svg" style={{ paddingRight: '0px' }}
                      content="" />Added Successfully</DialogComponent>

                  {/*Dialog Component For Updation Success*/}
                  <DialogComponent width='250px' id="update"
                    animationSettings={this.settings} header='Success'
                    showCloseIcon={true} buttons={this.Okbutton}
                    ref={dialog => this.dialogInstance = dialog}
                    visible={this.state.hideupdateDialog} close={this.dialogClose}>
                    <img src="assets/images/done.svg" style={{ paddingRight: '0px' }}
                      content="" />Updated Successfully</DialogComponent>

                  {/*Dialog Component For Deletion Confirmation*/}
                  <DialogComponent width='400px' animationSettings={this.settings}
                    header='KPI' showCloseIcon={true} buttons={this.buttons}
                    ref={dialog => this.dialogInstance = dialog}
                    visible={this.state.hideDeletePopup} close={this.dialogClose}>
                    <img src="assets/images/warn.svg" style={{ paddingRight: '0px', height: '20px', width: '20px' }}
                      content="" />&nbsp;Do you want to delete the KPI?
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Note: Press 'Yes' to delete or press 'No' to decline.</DialogComponent>

                  {/*Dialog Component For DeletionSuccess*/}
                  <DialogComponent width='250px' animationSettings={this.settings}
                    header='Success' showCloseIcon={true} buttons={this.deleteSuccessbuttons}
                    ref={dialog => this.dialogInstance = dialog} visible={this.state.hideDeleteSuccessPopup}
                    close={this.dialogClose}><img src="assets/images/done.svg" style={{ paddingRight: '0px' }}
                      content="" />Deleted Successfully</DialogComponent>

                </div>
                <div></div>
                {/* --------------------------------for SECOND CONTENT BODY-------------------------------------------------- */}
                <div class="col-lg-5" >
                  <div className="card">
                    <div style={{ align: "center", marginLeft: "10px" }}>

                      <h6 className="nav-item" style={{ color: '#282a65', marginTop: '20px' }}>Export File</h6>
                    </div>
                    <br />

                    <div className="row">
                      <div className="col-sm-2"></div>
                      <div className="col-sm-4" style={{ marginLeft: "5%" }}>

                        <button className="btn action-button" style={{ width: "230px", align: "center" }}
                          onClick={this.downloadFaq}>Export FAQs</button>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-sm-2"></div>
                      <div className="col-sm-4" style={{ marginLeft: "5%" }}>

                        <button className="btn action-button" style={{ width: "230px", align: "center" }}
                          onClick={this.downloadFaqAsXlsxApi}>Export FAQs as Xlsx</button>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-sm-2"></div>
                      <div className="col-sm-4" style={{ marginLeft: "5%" }}>

                        <button className="btn action-button" style={{ width: "230px", align: "center" }}
                          onClick={this.downloadSlusApi}>Export Intents &amp; Automations</button>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-sm-2"></div>
                      <div className="col-sm-4" style={{ marginLeft: "5%" }}>
                        <button className="btn action-button" style={{ width: "230px", align: "center" }}
                          onClick={this.downloadMltApi}>Export Automation Responses</button>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-sm-2"></div>
                      <div className="col-sm-4" style={{ marginLeft: "5%" }}>
                        <button className="btn action-button" style={{ width: "230px", align: "center" }}
                          onClick={this.downloadBackendApi}>Export Backend APIs</button>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-sm-2"></div>
                      <div className="col-sm-4" style={{ marginLeft: "5%" }}>
                        <button className="btn action-button" style={{ width: "230px", align: "center" }}
                          onClick={this.downloadEntitiesApi}>Export Multilingual Entities</button>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-sm-2"></div>
                      <div className="col-sm-4" style={{ marginLeft: "5%" }}>
                        <button className="btn action-button" style={{ width: "230px", align: "center" }}
                          onClick={this.downloadLangSpecEntitiesApi}>Export Language Specific Entities</button>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-sm-2"></div>
                      <div className="col-sm-4" style={{ marginLeft: "5%" }}>
                        <button className="btn action-button" style={{ width: "230px", align: "center" }}
                          onClick={this.downloadSubsApi}>Export Substitutions</button>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-sm-2"></div>
                      <div className="col-sm-4" style={{ marginLeft: "5%" }}>
                        <button className="btn action-button" style={{ width: "230px", align: "center" }}
                          onClick={this.downloadCustEntiApi}>Export Custom entity</button>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-sm-2"></div>
                      <div className="col-sm-4" style={{ marginLeft: "5%" }}>
                        <button className="btn action-button" style={{ width: "230px", align: "center" }}
                          onClick={this.downloadDialogDirectiveApi}>Export Incoming Dialog Directive</button>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-sm-2"></div>

                      <div className="col-sm-4" style={{ marginLeft: "5%" }}>
                        <button className="btn action-button" style={{ width: "230px", align: "center" }}
                          onClick={this.downloadOutputDDApi}>Export Outgoing Dialog Directive</button>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-sm-2"></div>
                      <div className="col-sm-4" style={{ marginLeft: "5%" }}>
                        <button className="btn action-button" style={{ width: "230px", align: "center" }}
                          onClick={this.downloadAbbreviationApi}>Export Abbreviation Text</button>
                      </div>
                    </div>
                    <div className="col-sm-4"></div>

                  </div>
                </div>
              </div>
            </div>
          </div>
        </div >
      </div >

    )
  }
}
export default ImportExportFiles;



// WEBPACK FOOTER //
// ./src/projectmgmt/settings/importExport/ImportExportFiles.js